<template>
  <div class="section motivation-section">
    <div class="container">
      <h3 class="title is-size-2 is-size-4-touch has-text-centered">
        Stay Motivated
      </h3>
      <p class="is-size-4 is-size-5-touch subtitle has-text-centered">
        Students can set daily targets and monitor their progress
      </p>
      <br />
      <div class="columns is-vcentered">
        <div class="column">
          <figure class="pic">
            <img
              :data-src="require('@/assets/target-mockup.webp')"
              class="lazyload"
              alt="Targets"
            />
          </figure>
        </div>
        <div class="column">
          <h4 class="title is-size-3 is-size-4-touch">
            Daily Targets
          </h4>
          <p class="subtitle is-size-5 is-size-6-touch">
            Choose a daily goal to keep you motivated.
          </p>
          <div class="content">
            <ul>
              <li>Number of recordings</li>
              <li>Seconds of reading</li>
              <li>Dictation words</li>
            </ul>
          </div>
        </div>
      </div>
      <br />
      <div class="columns is-vcentered">
        <div class="column">
          <figure class="pic">
            <img
              :data-src="require('@/assets/progress-mockups.webp')"
              class="lazyload"
              alt="Progress Reports"
            />
          </figure>
        </div>
        <div class="column">
          <h4 class="title is-size-3 is-size-4-touch">
            Progress Reports
          </h4>
          <p class="subtitle is-size-5 is-size-6-touch">
            See how you perform and keep on track
          </p>
          <div class="content">
            <ul>
              <li>Discipline report</li>
              <li>Targets report</li>
              <li>Dictation report</li>
              <li>Recordings</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.gif {
  border: 5px solid;
}
</style>
